import { useEffect } from 'react';
import useAuth from 'src/hooks/useAuth';
import { appInsights, SetAuthenticatedUserContext } from 'src/utils/appInsight';

interface AppInsightProps {
  name?: string;
  refUri?: string;
}

const useAppInsightPageView = ({ name, refUri }: AppInsightProps) => {
  const auth = useAuth();

  useEffect(() => {
    if (appInsights) {
      if(auth?.user?.name) {
        SetAuthenticatedUserContext(auth?.user?.name);
      }
      appInsights.trackPageView({
        name,
        refUri,
      });
    }
  }, [name, refUri, appInsights]);
};

export default useAppInsightPageView;
